import { Text, TextProps } from "@chakra-ui/react";

export const RowTitle = ({ children, ...props }: { children: string } & TextProps) => (
  <Text as="span" display="block" maxW={{ base: "40", md: "none" }} isTruncated title={children} {...props}>
    {children}
  </Text>
);
